import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import type { ResultOf } from 'gql.tada';
import linkMessages from '@/client/exchanges/cacheExchange/linkMessages';
import type { InsertMessage } from '@/components/Chat/ChatInput';

export default function insert_message_one(
  parent: {
    insert_message_one: ResultOf<typeof InsertMessage>['insert_message_one'];
  },
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  if (parent.insert_message_one) {
    linkMessages(cache, [parent.insert_message_one]);
  }
}
